import request from "@/utils/request";

/**
 * 分页查询事故列表
 */
export function selectPageList(data) {
    return request({
        url: "/report/incident/selectPageList",
        method: "post",
        data: data,
    });
}

/**
 * 创建事故
 */
export function createIncident(data) {
    return request({
        url: "/report/incident/create",
        method: "post",
        data: data,
    });
}

/**
 * 提交报告事故
 */
export function submitIncident(data) {
    return request({
        url: "/report/incident/submit",
        method: "post",
        data: data,
    });
}

/**
 * 事故结案
 */
export function settleIncident(data) {
    return request({
        url: "/report/incident/settle",
        method: "post",
        data: data,
    });
}

/**
 * 归档报告事故
 */
export function archiveIncident(data) {
    return request({
        url: "/report/incident/archive",
        method: "post",
        data: data,
    });
}

/**
 * 事故详情
 */
export function detailIncident(incidentId) {
    return request({
        url: "/report/incident/info?incidentId=" + incidentId,
        method: "get",
    });
}